var map = {
	"./Auth/ConfirmPassword": "./resources/js/Pages/Auth/ConfirmPassword.vue",
	"./Auth/ConfirmPassword.vue": "./resources/js/Pages/Auth/ConfirmPassword.vue",
	"./Auth/ForgotPassword": "./resources/js/Pages/Auth/ForgotPassword.vue",
	"./Auth/ForgotPassword.vue": "./resources/js/Pages/Auth/ForgotPassword.vue",
	"./Auth/Login": "./resources/js/Pages/Auth/Login.vue",
	"./Auth/Login.vue": "./resources/js/Pages/Auth/Login.vue",
	"./Auth/Register": "./resources/js/Pages/Auth/Register.vue",
	"./Auth/Register.vue": "./resources/js/Pages/Auth/Register.vue",
	"./Auth/ResetPassword": "./resources/js/Pages/Auth/ResetPassword.vue",
	"./Auth/ResetPassword.vue": "./resources/js/Pages/Auth/ResetPassword.vue",
	"./Auth/VerifyEmail": "./resources/js/Pages/Auth/VerifyEmail.vue",
	"./Auth/VerifyEmail.vue": "./resources/js/Pages/Auth/VerifyEmail.vue",
	"./Farmer/Bulk": "./resources/js/Pages/Farmer/Bulk.vue",
	"./Farmer/Bulk.vue": "./resources/js/Pages/Farmer/Bulk.vue",
	"./Farmer/Form": "./resources/js/Pages/Farmer/Form.vue",
	"./Farmer/Form.vue": "./resources/js/Pages/Farmer/Form.vue",
	"./Farmer/Index": "./resources/js/Pages/Farmer/Index.vue",
	"./Farmer/Index.vue": "./resources/js/Pages/Farmer/Index.vue",
	"./Farmer/Partials/FarmWidget": "./resources/js/Pages/Farmer/Partials/FarmWidget.vue",
	"./Farmer/Partials/FarmWidget.vue": "./resources/js/Pages/Farmer/Partials/FarmWidget.vue",
	"./Farmer/Partials/Farms": "./resources/js/Pages/Farmer/Partials/Farms.vue",
	"./Farmer/Partials/Farms.vue": "./resources/js/Pages/Farmer/Partials/Farms.vue",
	"./Farmer/Partials/Information": "./resources/js/Pages/Farmer/Partials/Information.vue",
	"./Farmer/Partials/Information.vue": "./resources/js/Pages/Farmer/Partials/Information.vue",
	"./Farmer/Partials/Reports": "./resources/js/Pages/Farmer/Partials/Reports.vue",
	"./Farmer/Partials/Reports.vue": "./resources/js/Pages/Farmer/Partials/Reports.vue",
	"./Farmer/Partials/Tasks": "./resources/js/Pages/Farmer/Partials/Tasks.vue",
	"./Farmer/Partials/Tasks.vue": "./resources/js/Pages/Farmer/Partials/Tasks.vue",
	"./Farmer/Partials/Users": "./resources/js/Pages/Farmer/Partials/Users.vue",
	"./Farmer/Partials/Users.vue": "./resources/js/Pages/Farmer/Partials/Users.vue",
	"./Farmer/View": "./resources/js/Pages/Farmer/View.vue",
	"./Farmer/View.vue": "./resources/js/Pages/Farmer/View.vue",
	"./Organisation/Create": "./resources/js/Pages/Organisation/Create.vue",
	"./Organisation/Create.vue": "./resources/js/Pages/Organisation/Create.vue",
	"./Organisation/Edit": "./resources/js/Pages/Organisation/Edit.vue",
	"./Organisation/Edit.vue": "./resources/js/Pages/Organisation/Edit.vue",
	"./Organisation/Index": "./resources/js/Pages/Organisation/Index.vue",
	"./Organisation/Index.vue": "./resources/js/Pages/Organisation/Index.vue",
	"./Organisation/Partials/Farmers": "./resources/js/Pages/Organisation/Partials/Farmers.vue",
	"./Organisation/Partials/Farmers.vue": "./resources/js/Pages/Organisation/Partials/Farmers.vue",
	"./Organisation/Partials/Information": "./resources/js/Pages/Organisation/Partials/Information.vue",
	"./Organisation/Partials/Information.vue": "./resources/js/Pages/Organisation/Partials/Information.vue",
	"./Organisation/Partials/Labs": "./resources/js/Pages/Organisation/Partials/Labs.vue",
	"./Organisation/Partials/Labs.vue": "./resources/js/Pages/Organisation/Partials/Labs.vue",
	"./Organisation/Partials/Reports": "./resources/js/Pages/Organisation/Partials/Reports.vue",
	"./Organisation/Partials/Reports.vue": "./resources/js/Pages/Organisation/Partials/Reports.vue",
	"./Organisation/Partials/SoilSamplers": "./resources/js/Pages/Organisation/Partials/SoilSamplers.vue",
	"./Organisation/Partials/SoilSamplers.vue": "./resources/js/Pages/Organisation/Partials/SoilSamplers.vue",
	"./Organisation/Partials/Tasks": "./resources/js/Pages/Organisation/Partials/Tasks.vue",
	"./Organisation/Partials/Tasks.vue": "./resources/js/Pages/Organisation/Partials/Tasks.vue",
	"./Organisation/Partials/Users": "./resources/js/Pages/Organisation/Partials/Users.vue",
	"./Organisation/Partials/Users.vue": "./resources/js/Pages/Organisation/Partials/Users.vue",
	"./Organisation/View": "./resources/js/Pages/Organisation/View.vue",
	"./Organisation/View.vue": "./resources/js/Pages/Organisation/View.vue",
	"./Profile/Index": "./resources/js/Pages/Profile/Index.vue",
	"./Profile/Index.vue": "./resources/js/Pages/Profile/Index.vue",
	"./Settings/Index": "./resources/js/Pages/Settings/Index.vue",
	"./Settings/Index.vue": "./resources/js/Pages/Settings/Index.vue",
	"./SoilAnalysis/Import": "./resources/js/Pages/SoilAnalysis/Import.vue",
	"./SoilAnalysis/Import.vue": "./resources/js/Pages/SoilAnalysis/Import.vue",
	"./SoilAnalysis/Partials/Charts": "./resources/js/Pages/SoilAnalysis/Partials/Charts.vue",
	"./SoilAnalysis/Partials/Charts.vue": "./resources/js/Pages/SoilAnalysis/Partials/Charts.vue",
	"./SoilAnalysis/Partials/CsvImportTasks": "./resources/js/Pages/SoilAnalysis/Partials/CsvImportTasks.vue",
	"./SoilAnalysis/Partials/CsvImportTasks.vue": "./resources/js/Pages/SoilAnalysis/Partials/CsvImportTasks.vue",
	"./Task/Create": "./resources/js/Pages/Task/Create.vue",
	"./Task/Create.vue": "./resources/js/Pages/Task/Create.vue",
	"./Task/Edit": "./resources/js/Pages/Task/Edit.vue",
	"./Task/Edit.vue": "./resources/js/Pages/Task/Edit.vue",
	"./Task/EditRecord": "./resources/js/Pages/Task/EditRecord.vue",
	"./Task/EditRecord.vue": "./resources/js/Pages/Task/EditRecord.vue",
	"./Task/Index": "./resources/js/Pages/Task/Index.vue",
	"./Task/Index.vue": "./resources/js/Pages/Task/Index.vue",
	"./Task/Partials/Actions": "./resources/js/Pages/Task/Partials/Actions.vue",
	"./Task/Partials/Actions.vue": "./resources/js/Pages/Task/Partials/Actions.vue",
	"./Task/Partials/Comments": "./resources/js/Pages/Task/Partials/Comments.vue",
	"./Task/Partials/Comments.vue": "./resources/js/Pages/Task/Partials/Comments.vue",
	"./Task/Partials/Details": "./resources/js/Pages/Task/Partials/Details.vue",
	"./Task/Partials/Details.vue": "./resources/js/Pages/Task/Partials/Details.vue",
	"./Task/Partials/Records": "./resources/js/Pages/Task/Partials/Records.vue",
	"./Task/Partials/Records.vue": "./resources/js/Pages/Task/Partials/Records.vue",
	"./Task/Partials/Records_backup": "./resources/js/Pages/Task/Partials/Records_backup.vue",
	"./Task/Partials/Records_backup.vue": "./resources/js/Pages/Task/Partials/Records_backup.vue",
	"./Task/Partials/Reports": "./resources/js/Pages/Task/Partials/Reports.vue",
	"./Task/Partials/Reports.vue": "./resources/js/Pages/Task/Partials/Reports.vue",
	"./Task/Partials/Reports_backup": "./resources/js/Pages/Task/Partials/Reports_backup.vue",
	"./Task/Partials/Reports_backup.vue": "./resources/js/Pages/Task/Partials/Reports_backup.vue",
	"./Task/View": "./resources/js/Pages/Task/View.vue",
	"./Task/View.vue": "./resources/js/Pages/Task/View.vue",
	"./User/Create": "./resources/js/Pages/User/Create.vue",
	"./User/Create.vue": "./resources/js/Pages/User/Create.vue",
	"./User/Edit": "./resources/js/Pages/User/Edit.vue",
	"./User/Edit.vue": "./resources/js/Pages/User/Edit.vue",
	"./User/Index": "./resources/js/Pages/User/Index.vue",
	"./User/Index.vue": "./resources/js/Pages/User/Index.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/Pages sync recursive ^\\.\\/.*$";